import React, { FC } from 'react'
import "../css/sectionTitleView.css"

interface SectionTitleViewProp{
    span?: string;
    title?: string;
    paragraph?: string;
}

const SectionTitleView:FC<SectionTitleViewProp> = (props) => {
  return (
    <section className='scl--stv-con-bo-str'>
        <div className='scl-scbs-mai-ti-con-str'>
            [<span> {props.span} </span>]
        </div>
        
        <div className='scl--scbs-sec-ti-con-bo-str'>
            <div className='scl--sstcbs-ti-str'>{props.title} </div>
            <div className='sc--sstcbs-pa-str'>{props.paragraph}</div>
        </div>
    </section>
  )
}

export default SectionTitleView